<template>
    <div class="container">
        <div class="row">
            <div class="col-12 text-center">
                <h4 class="title">404 Not Found</h4>
                <h4 class="title">Oops! It seems that this page does not exist.</h4>
            </div>
        </div>
    </div>

</template>

<script>
    export default {}

</script>
